import type { Team } from '@halvard/rules';
import type { Square } from './types.js';

const STEPS: Readonly<Record<string, [number, number]>> = {
  ArrowUp: [-1, 0],
  ArrowDown: [1, 0],
  ArrowLeft: [0, -1],
  ArrowRight: [0, 1],
};

/**
 * Moves the keyboard cursor so arrows follow the screen: seen from Ivory's side, up goes
 * towards Basalt (rank 9); seen from Basalt's side everything is mirrored.
 * Returns `null` for keys that do not move the cursor.
 */
export function moveCursor(cursor: Square, key: string, facing: Team): Square | null {
  const step = STEPS[key];
  if (!step) return null;
  const sign = facing === 'I' ? 1 : -1;
  return {
    r: Math.min(8, Math.max(0, cursor.r + step[0] * sign)),
    c: Math.min(8, Math.max(0, cursor.c + step[1] * sign)),
  };
}

/** Rows and columns in screen order (top-left first) for the side the viewer faces. */
export function screenOrder(facing: Team): number[] {
  const order = [0, 1, 2, 3, 4, 5, 6, 7, 8];
  return facing === 'I' ? order : order.reverse();
}
